<template>
  <table v-table-resizer class="table table-striped">
    <thead>
      <tr>
        <th class="fandom">Tag</th>
        <th class="prompts">Requests</th>
      </tr>
    </thead>
    <tbody v-if="!updating && !processing && filtered.length">
      <tr v-for="(row, i) in filtered" :key="`${exchangeId}-${options.groupBy}-${i}`">
        <td class="tag" data-label="Tag">
          <router-link class="text-bold" :to="`/${exchangeId}/group/${options.groupBy.toLowerCase()}/${encodeURIComponent(
            row.tag
          )}`">{{ row.tag }}</router-link>&nbsp;
          <!-- Only allow bookmarks for closed collections for sanity's sake -->
          <template v-if="options.groupBy.toLowerCase() == 'freeform'">
            <button class="bookmark" @click="toggleFreeformmark(row.tag)">
              <span v-if="hasFreeformmark(row.tag)" class="fas fa-heart"></span>
              <span v-else class="far fa-heart" aria-label="Bookmark"></span>
            </button>
          </template>
          <template v-if="options.groupBy.toLowerCase() == 'relationship'">
            <button class="bookmark" @click="toggleRelationshipmark(row.tag)">
              <span v-if="hasRelationshipmark(row.tag)" class="fas fa-heart"></span>
              <span v-else class="far fa-heart" aria-label="Bookmark"></span>
            </button>
          </template>


        </td>
        <td class="prompts">
          <button class="btn btn-primary" v-if="!getPrompts(row)" @click="getTagPrompts(row)">
            Show Requests
          </button>

          <div v-if="getPrompts(row) === 'loading'" class="loading"></div>
          <keep-alive>
            <prompt-table :showFandom="true" :prompts="getPrompts(row)" v-if="shouldShowPrompts(row.tag)">
            </prompt-table>
          </keep-alive>
        </td>
      </tr>
    </tbody>
  </table>
</template>


<script>
import PromptTable from "./promptTable.vue";
import utils from "./utils.js";
import tableResizer from "../directives/tableResizer";
// third party
import { mapGetters } from "vuex";
import data from "../store/data";

const cyrb53 = function (str, seed = 0) {
  if (!str) return "";
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 =
    Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
    Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 =
    Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
    Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

export default {
  name: "groupedTable",
  directives: {
    tableResizer
  },
  components: {
    PromptTable
  },
  props: {
    updating: {
      type: Boolean,
      default: true
    },
    processing: {
      type: Boolean,
      default: true
    },
    filtered: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters([
      "exchangeId",
      "isExchangeOpen",
      "bookmarks",
      "categories",
      "characters",
      "fandoms",
      "letters",
      "loadAll",
      "loaded",
      "loadedChars",
      "options",
      "promptmarks"
    ])
  },
  data() {
    return {
      prompts: {}
    };
  },
  methods: {
    ...utils,
    getPrompts(tag) {
      const id = cyrb53(tag.tag).toString();
      return this.prompts[id];
    },

    async getTagPrompts(tag) {
      if (!this.exchangeId) {
        return;
      }
      // todo: server send tag.id
      const id = cyrb53(tag.tag).toString();
      let newVal = this.prompts;
      this.prompts = {};

      newVal[id] = "loading";
      this.prompts = newVal;

      let requests;
      const escapedTag = encodeURIComponent(tag.tag);
      const exchange = encodeURIComponent(this.exchangeId);

      switch (this.options.groupBy.toLowerCase()) {
        default:
        case "freeform":
          requests = await data.getExchangeFreeformRequests(
            exchange,
            escapedTag
          );
          break;
        case "relationship":
          requests = await data.getExchangeRelationshipRequests(
            exchange,
            escapedTag
          );
          break;
        case "character":
          requests = await data.getExchangeCharacterRequests(
            exchange,
            escapedTag
          );
          break;
      }
      this.prompts = {};

      newVal[id] = requests;
      this.prompts = newVal;
    },
    cyrb53,
    shouldShowPrompts(tag) {
      const id = cyrb53(tag).toString();

      return (
        this.prompts[id] &&
        this.prompts[id].length &&
        this.prompts[id] !== "loading"
      );
    }
  }
};
</script>